import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import WelcomeDashboard from "./pages/WelcomeDashboard";
import PersonelListePage from "./pages/PersonelListePage";
import IstifaPage from "./pages/IstifaPage";
import ManavListPage from "./pages/ManavListPage";
import VeriGirisiPage from "./pages/VeriGirisiPage";
import PersonelDevamListPage from "./pages/PersonelDevamListPage";
import ZRaporPage from "./pages/ZRaporPage";
import { isPageDisabled } from "./data/disabledPages";

const PrivateRoute = ({ children, path }) => {
  const { isLogged } = useAuth();
  if (!isLogged) return <Navigate to="/login" replace />;
  if (path && isPageDisabled(path)) return <Navigate to="/dashboard" replace />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <WelcomeDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/personel"
          element={
            <PrivateRoute>
              <PersonelListePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/istifa"
          element={
            <PrivateRoute>
              <IstifaPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/manav"
          element={
            <PrivateRoute path="/manav">
              <ManavListPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/veri-girisi"
          element={
            <PrivateRoute path="/veri-girisi">
              <VeriGirisiPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/devam"
          element={
            <PrivateRoute>
              <PersonelDevamListPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/zrapor"
          element={
            <PrivateRoute path="/zrapor">
              <ZRaporPage />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
